<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input #input class="decimal" currencyMask matInput [formControlName]="config.name" [options]="{ prefix: '% ', decimal: ',' }" [min]="0"
    [max]="100"
    (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
  (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
    />
  <!-- <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
    <span>Campo Obrigatório</span>
  </mat-error> -->
</mat-form-field>
